module.exports = __webpack_public_path__ + "static/img/img_2.874f9ccf.jpg";